export const IMAGES = {
  portrait: "/melinda-portrait.webp",
  desk: "https://images.unsplash.com/photo-1600188769045-bc6026bfc8cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxlZGl0b3JpYWwlMjBwb3J0cmFpdCUyMHdyaXRlciUyMHdvbWFuJTIwYWVzdGhldGljJTIwdmludGFnZSUyMGNsYXNzaWMlMjBwYXBlciUyMHN0dWRpb3xlbnwwfHx8fDE3ODk4ODAxNjd8MA&ixlib=rb-4.1.0&q=85",
  typewriter:
    "https://images.unsplash.com/reserve/LJIZlzHgQ7WPSh5KVTCB_Typewriter.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwdHlwZXdyaXRlciUyMHBhcGVyJTIwbGl0ZXJhcnklMjBib29rJTIwYWVzdGhldGljJTIwZWRpdG9yaWFsJTIwZGFyayUyMGlua3xlbnwwfHx8fDE3ODk4ODAxNjd8MA&ixlib=rb-4.1.0&q=85",
  lamp: "https://images.unsplash.com/photo-1530819568329-97653eafbbfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHx2aW50YWdlJTIwdHlwZXdyaXRlciUyMHBhcGVyJTIwbGl0ZXJhcnklMjBib29rJTIwYWVzdGhldGljJTIwZWRpdG9yaWFsJTIwZGFyayUyMGlua3xlbnwwfHx8fDE3ODk4ODAxNjd8MA&ixlib=rb-4.1.0&q=85",
  books: "https://images.pexels.com/photos/9758166/pexels-photo-9758166.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  magazine: "https://images.pexels.com/photos/4271614/pexels-photo-4271614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const FILTERS = [
  "All",
  "Brand Copy",
  "Product Copy",
  "SEO Editorial",
  "Lifecycle Email",
  "UX Writing",
  "Campaign",
];

export const SAMPLES = [
  {
    id: "mv-home",
    client: "MemoryVault",
    category: "Brand Copy",
    title: "Homepage — Every Story Deserves a Place to Stay",
    hook: "Every story deserves a place to stay.",
    excerpt:
      "Turn photos, voice recordings, videos, and family stories into a private digital archive you will actually revisit.",
    type: "Website copy",
    words: "~210",
    note: "Leads with the emotional truth, then earns the product. Objections are answered in the reader's own words.",
    body: [
      "Turn photos, voice recordings, videos, and family stories into a private digital archive you will actually revisit.",
      "Your memories are already everywhere. A birthday video is on an old phone. A favorite recipe is written on an index card. A relative remembers the story behind a faded photograph, but the story has never been recorded. MemoryVault brings those pieces together so the meaning does not get separated from the moment.",
      "Begin with one memory. You do not need to organize years of files before you start. Choose one photo, recording, document, or story. Add what you remember. Invite someone else to contribute when you are ready.",
      "\u201cI am not organized enough.\u201d You do not need to be. Start with one memory. MemoryVault helps you add context as you go, and you can adjust details later.",
    ],
  },
  {
    id: "vh-home",
    client: "VoltHaus",
    category: "Brand Copy",
    title: "Homepage Hero & Value Proposition",
    hook: "Find the tech that fits your life.",
    excerpt:
      "Expert-curated electronics, smart-home devices, and gaming gear, with useful recommendations from people who understand the products.",
    type: "Website copy",
    words: "~180",
    note: "Positions curation as the product. Every claim is written to survive a compliance review.",
    body: [
      "Expert-curated electronics, smart-home devices, and gaming gear, with useful recommendations from people who understand the products.",
      "Curated, not cluttered. VoltHaus does not try to stock everything. The assortment is organized around strong use cases, documented specifications, and a clearer path to comparison.",
      "Expert guidance, zero pressure. Tech advisors help customers compare the fit, tradeoffs, and value of each option.",
      "Shipping and returns, explained clearly. Delivery thresholds, timing, return windows, restocking fees, and exclusions should be displayed using verified operational policy instead of buried in fine print.",
    ],
  },
  {
    id: "vh-ultrabook",
    client: "VoltHaus",
    category: "Product Copy",
    title: "UltraBook Pro 16 — Product Page",
    hook: "Desktop power. Carry-on weight.",
    excerpt:
      "Built for creators who refuse to compromise, whether rendering video, compiling code, or managing a research session with more tabs than anyone wants to admit.",
    type: "Product page",
    words: "~240",
    note: "Spec-heavy product language translated into creator outcomes — with every performance claim flagged for verification.",
    body: [
      "Built for creators who refuse to compromise, whether rendering video, compiling code, or managing a research session with more tabs than anyone wants to admit.",
      "M3 Pro chip. A 12-core CPU and 18-core GPU. The \u201c40% faster rendering\u201d comparison requires a defined benchmark, test configuration, comparator, and source.",
      "32GB unified memory. Positioned for demanding creative applications and multitasking.",
      "120Hz Mini-LED display. Specified at 1,600 words of peak brightness with P3 wide color.",
      "22-hour battery. Battery life varies by configuration and use — replace with verified test language and link to methodology.",
    ],
  },
  {
    id: "vh-aegis",
    client: "VoltHaus",
    category: "Product Copy",
    title: "Aegis Wireless Gaming Headset",
    hook: "Hear them before they see you.",
    excerpt:
      "Pinpoint audio, long-session comfort, and a microphone designed to keep the focus on the match.",
    type: "Product page",
    words: "~200",
    note: "Competitive energy without promising competitive outcomes — features are framed around experience, not guarantees.",
    body: [
      "Pinpoint audio, long-session comfort, and a microphone designed to keep the focus on the match.",
      "7.1 surround sound. Position the feature around directional awareness without guaranteeing competitive outcomes.",
      "40-hour battery. State verified test conditions; the rapid-charge claim requires documented timing and configuration.",
      "Memory foam ear cushions. Describe material and fit without promising the absence of pressure points for every user.",
      "Detachable noise-canceling mic. Explain verified microphone processing, controls, and removal behavior.",
    ],
  },
  {
    id: "vh-laptop-seo",
    client: "VoltHaus",
    category: "SEO Editorial",
    title: "How to Choose the Right Laptop for Your Workflow",
    hook: "Start with the workflow, not the spec sheet.",
    excerpt:
      "The useful question is not \u201cwhich model has the most impressive specification sheet?\u201d It is \u201cwhat will this computer need to do most of the time?\u201d",
    type: "SEO article",
    words: "~1,400",
    note: "Targets \u201chow to choose a laptop\u201d with informational intent, then opens a contextual path to expert help.",
    body: [
      "A laptop comparison page can turn a simple upgrade into a wall of acronyms. The useful question is not \u201cWhich model has the most impressive specification sheet?\u201d It is \u201cWhat will this computer need to do most of the time?\u201d",
      "The best laptop is not the one with the highest benchmark score. It is the one that fits the work, software, budget, and portability needs in front of you.",
      "Define the primary use case first. General productivity covers browsing, email, calls, and writing. Creative work may include photography, video, design, and music. Development may involve compiling, local environments, containers, or virtual machines.",
      "Talk to a human. Specifications narrow the field. Daily experience decides the fit. Ask about keyboard feel, display reflections, fan noise, heat, setup, warranty, and the return policy.",
    ],
  },
  {
    id: "mv-blog",
    client: "MemoryVault",
    category: "SEO Editorial",
    title: "How to Preserve Family Memories in the Digital Age",
    hook: "Start with meaning, not volume.",
    excerpt:
      "The idea of organizing every family photo can stop a preservation project before it begins. Instead, start with the memory that carries the most meaning.",
    type: "Long-form blog",
    words: "~1,200",
    note: "Built from an SEO brief: informational intent, a conversion goal of one first-memory upload, delivered through genuinely useful guidance.",
    body: [
      "The idea of organizing every family photo can stop a preservation project before it begins. Instead of starting with the largest folder, start with the memory that carries the most meaning. A meaningful first item creates momentum because the value is immediately visible.",
      "Gather context while it is available. A file can survive while its meaning disappears. A photograph may remain perfectly clear even after no one remembers the names, location, or reason everyone was gathered.",
      "Make preservation a small habit. Set aside ten minutes after a trip, celebration, or family visit to add context to a few items. Small habits protect more meaning than a perfect system that never begins.",
      "The most valuable archive is not necessarily the largest. It is the one that keeps moments understandable, findable, and connected to the people who care about them.",
    ],
  },
  {
    id: "vh-welcome",
    client: "VoltHaus",
    category: "Lifecycle Email",
    title: "Welcome Flow — First Purchase",
    hook: "Here's $20 off your first order",
    excerpt:
      "Tech shopping can feel overwhelming. Specifications, acronyms, and endless comparison charts can turn a simple purchase into a research project.",
    type: "Lifecycle email",
    words: "~160",
    note: "One primary action, verified offer inputs, and personalization fallbacks — the lifecycle principle, applied.",
    body: [
      "Subject A: Welcome to VoltHaus \u203a \u2014 Subject B: Here's $20 off your first order.",
      "Preheader: Let's find the tech that fits your life.",
      "Welcome to VoltHaus. Tech shopping can feel overwhelming. Specifications, acronyms, and endless comparison charts can turn a simple purchase into a research project. VoltHaus takes a different approach.",
      "Tech advisors help customers understand the fit and tradeoffs of each option, while the assortment is organized around real workflows rather than the longest possible product list.",
      "Start with the two-minute Tech Match Quiz. Tell us about the workflow, budget, and preferences, and receive a practical place to begin. Here is $20 off an eligible first order: WELCOME20.",
    ],
  },
  {
    id: "vh-cart",
    client: "VoltHaus",
    category: "Lifecycle Email",
    title: "Abandoned Cart — Did You Get Distracted?",
    hook: "Did you get distracted?",
    excerpt:
      "Something pulled the attention away. Maybe a meeting started. Maybe the specification comparison is still open in another tab.",
    type: "Lifecycle email",
    words: "~120",
    note: "Recovers the order by respecting why the reader left — then removes every practical doubt before checkout.",
    body: [
      "Preheader: Your cart is still waiting for you.",
      "Something pulled the attention away. Maybe a meeting started. Maybe the specification comparison is still open in another tab. Either way, the cart is saved so the order does not need to be rebuilt.",
      "Before checking out, confirm: the selected model, configuration, and color; compatibility with required devices and accessories; current shipping threshold and delivery estimate; verified return, restocking-fee, and warranty terms.",
    ],
  },
  {
    id: "mv-onboard",
    client: "MemoryVault",
    category: "Lifecycle Email",
    title: "Onboarding — Begin With One Memory",
    hook: "Welcome to MemoryVault",
    excerpt:
      "Before uploading thousands of photos, start with just one memory. A favorite family vacation. A meaningful birthday. A handwritten recipe.",
    type: "Onboarding email",
    words: "~140",
    note: "First of a five-email activation sequence. Each email asks for exactly one meaningful action.",
    body: [
      "Preheader: Let's protect the memories that matter most.",
      "Thanks for joining MemoryVault. Before uploading thousands of photos, start with just one memory. A favorite family vacation. A meaningful birthday. A handwritten recipe. An old voice recording.",
      "Choose the moment you would be most disappointed to lose. Add the file, then write one sentence about why it matters. That is enough to begin.",
      "The easiest archive to manage is the one you start today.",
    ],
  },
  {
    id: "mv-ux",
    client: "MemoryVault",
    category: "UX Writing",
    title: "First-Memory Onboarding Flow",
    hook: "What would you like to preserve?",
    excerpt:
      "Photo \u2022 Video \u2022 Voice recording \u2022 Document \u2022 Written story — every step uses customer-recognizable language and reduces pressure to complete every field.",
    type: "UX writing",
    words: "~180",
    note: "Five steps, five content decisions: visibility becomes a deliberate choice, and success never blocks the next step.",
    body: [
      "Step 1 — What would you like to preserve? Photo \u2022 Video \u2022 Voice recording \u2022 Document \u2022 Written story. Uses customer-recognizable content types.",
      "Step 2 — Add the memory. Choose a file or start writing. You can add more details later. Reduces pressure to complete every field.",
      "Step 3 — What should people know? Add names, a date, a place, or a short story. Explains the value of metadata in human language.",
      "Empty archive state: Your archive is ready for its first story.",
      "Upload error: We could not finish this upload. Your description is saved. Check your connection and try the file again.",
      "Success: Your memory is safe in your archive and ready to revisit.",
    ],
  },
  {
    id: "mv-campaign",
    client: "MemoryVault",
    category: "Campaign",
    title: "The Gift of Being Remembered",
    hook: "Give a story a place to stay.",
    excerpt:
      "Choose a photograph. Record the story behind it. Invite someone you love to add what they remember.",
    type: "Seasonal campaign",
    words: "~150",
    note: "Emotion earned through specific moments — with a guardrail against promising permanence the product cannot verify.",
    body: [
      "Choose a photograph. Record the story behind it. Invite someone you love to add what they remember. The most meaningful family archive can begin with one shared moment.",
      "Email subject options: \u201cA gift only your family can make\u201d \u2022 \u201cStart with one story worth keeping\u201d \u2022 \u201cBefore the gathering ends, record the story.\u201d",
      "Landing CTA: Create a shared collection.",
      "Guardrail: the campaign avoids promising permanence, security, or intergenerational outcomes that the product and policy teams have not verified.",
    ],
  },
  {
    id: "mv-social",
    client: "MemoryVault",
    category: "Campaign",
    title: "Five-Post Educational Series",
    hook: "A file is not the same as a preserved memory.",
    excerpt:
      "The file holds the image. The story holds the names, place, reason, and voice that make the image meaningful.",
    type: "Social campaign",
    words: "~200",
    note: "Five posts, five ideas — each one teachable in a single scroll, each one ending in a doable action.",
    body: [
      "Post 01 — A file is not the same as a preserved memory. The file holds the image. The story holds the names, place, reason, and voice that make the image meaningful. This week, choose one photograph and add what only your family knows.",
      "Post 02 — Do not start with every photo. Start with the one you would be most disappointed to lose. A small, meaningful beginning is easier to continue than a perfect system.",
      "Post 03 — Ask a better question. Instead of \u201cWhat do you remember?\u201d try \u201cWhat happened in this kitchen on an ordinary morning?\u201d Specific questions help specific stories surface.",
      "Post 05 — The best archive is one people can understand. Storage protects a file. Context helps another person recognize why the file mattered.",
    ],
  },
];

export const BEFORE_AFTER = {
  title: "The Win-Back Rewrite",
  context:
    "VoltHaus lifecycle, flow 4. The brief supplied a familiar \u201cwe miss you\u201d concept. Here is what shipped instead.",
  before: {
    label: "The supplied concept",
    text: "We miss you! It's been so long since your last visit. Come back and see what's new \u2014 we'd love to have you. Here's a little something to welcome you back.",
  },
  after: {
    label: "The rewrite",
    text: "Ready for a setup refresh? It has been a while. Maybe the current setup still works perfectly. If something has changed \u2014 a new workflow, new room, new game, or a device that no longer keeps up \u2014 VoltHaus can help identify a practical next step.",
  },
  rationale:
    "The revision centers customer relevance instead of brand neediness. The offer creates the reason to return, while the copy preserves the option not to upgrade.",
};

export const SERVICES = [
  {
    title: "Website & Product Copy",
    desc: "Homepages, value propositions, and product pages that translate specifications into outcomes a customer can feel.",
    tags: ["Heroes", "Product pages", "Comparison language"],
  },
  {
    title: "SEO Editorial",
    desc: "Keyword-led articles and guides that answer real intent first, then open a natural path to the product.",
    tags: ["Briefs", "Long-form", "Metadata"],
  },
  {
    title: "Lifecycle Email",
    desc: "Welcome, abandoned cart, post-purchase, and win-back flows — each message with one primary action and a measurement plan.",
    tags: ["Klaviyo-style flows", "A/B subjects", "Suppression logic"],
  },
  {
    title: "UX Writing & Microcopy",
    desc: "Onboarding, empty states, errors, and permissions written in customer-recognizable language that never blocks success.",
    tags: ["Onboarding", "Empty states", "Errors"],
  },
  {
    title: "Campaigns & Seasonal",
    desc: "Big campaign ideas carried through landing pages, paid social, and search — with guardrails on every claim.",
    tags: ["Concepts", "Paid social", "Search ads"],
  },
  {
    title: "Voice & AI-Assisted Workflow",
    desc: "Voice systems and prompt patterns that speed up ideation while a human keeps ownership of every shipped word.",
    tags: ["Voice guides", "Prompt patterns", "QA"],
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Brief & Verified Inputs",
    desc: "Audience, objective, approved specifications, offer, policy, channel, voice, prohibited claims, and reviewers — gathered before a single line is drafted.",
  },
  {
    step: "02",
    title: "Assisted Exploration",
    desc: "Headline territories, subject-line contrasts, content clustering, and controlled variations. One relief-led, one performance-led, one value-led.",
  },
  {
    step: "03",
    title: "Human Curation & Writing",
    desc: "Select the strategic direction, rewrite generic output, add product-specific meaning, and ensure the copy supports the customer decision.",
  },
  {
    step: "04",
    title: "Compliance & Accuracy",
    desc: "Every performance statement, comparison, compatibility claim, shipping promise, offer, review, warranty, and policy detail gets checked.",
  },
  {
    step: "05",
    title: "Handoff & Measurement",
    desc: "Approved copy is logged with owner, dependencies, review status, test hypothesis, target metric, launch date, and readout date.",
  },
];

export const VOICES = [
  {
    quote:
      "Melinda writes the kind of copy you only notice because everything suddenly makes sense. Our product pages stopped reading like spec sheets and started reading like advice from a friend who happens to know laptops.",
    name: "Marketing Director",
    org: "Consumer electronics retailer",
    mark: "Illustrative endorsement",
  },
  {
    quote:
      "She flagged three claims in our own brief that legal would have caught in week two. The copy shipped on time, and every word of it survived review untouched.",
    name: "Product Lead",
    org: "Smart-home platform",
    mark: "Illustrative endorsement",
  },
  {
    quote:
      "The win-back email she rewrote outperformed our control by a wide margin \u2014 and it did it by respecting the customer instead of begging.",
    name: "Lifecycle Manager",
    org: "D2C subscription brand",
    mark: "Illustrative endorsement",
  },
];

export const EMAIL = "leeadamscompanyusa@zohomail.com";

export const LINKEDIN = "https://www.linkedin.com/in/melinda-adams-8284a45a";

export const MARQUEE_ITEMS = [
  "Brand Voice",
  "SEO Editorial",
  "Lifecycle Email",
  "UX Writing",
  "Product Copy",
  "Seasonal Campaigns",
  "Narrative Strategy",
  "Verified Claims",
];

